
import React, { useState } from 'react';
import { 
  Wifi, 
  Tv, 
  Car, 
  Coffee, 
  UtensilsCrossed,
  Bath,
  Gamepad2,
  Wind,
  Umbrella,
  Droplets,
  Heater,
  Shirt,
  Baby,
  Sun,
  Bed,
  BedDouble,
  Home,
  Snowflake,
  ChefHat,
  Table,
  Trees,
  WashingMachine,
  DoorOpen,
  Sofa,
  Scale,
  Music,
  Weight,
  Book,
  Palette,
  Users,
  Armchair,
  Flame,
} from 'lucide-react';
import { Separator } from "./ui/separator";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";
import { ScrollArea } from "./ui/scroll-area";

type Amenity = {
  name: string;
  icon: React.ReactNode;
};

type AmenityCategory = {
  category: string;
  items: Amenity[];
};

const amenities: Amenity[] = [
  {
    name: "3 Chambres",
    icon: <Bed className="h-5 w-5" />,
  },
  {
    name: "2 Salles de bain",
    icon: <Bath className="h-5 w-5" />,
  },
  {
    name: "Parking privé",
    icon: <Car className="h-5 w-5" />,
  },
  {
    name: "Terrasse en bois de 75m²",
    icon: <Home className="h-5 w-5" />,
  },
  {
    name: "Jardin clos",
    icon: <Trees className="h-5 w-5" />,
  },
  {
    name: "Barbecue à gaz",
    icon: <Flame className="h-5 w-5" />,
  },
  {
    name: "Téléviseur connecté 55 pouces",
    icon: <Tv className="h-5 w-5" />,
  },
  {
    name: "Wifi",
    icon: <Wifi className="h-5 w-5" />,
  },
  {
    name: "Jeux de société",
    icon: <Gamepad2 className="h-5 w-5" />,
  },
  {
    name: "Cuisine équipée",
    icon: <ChefHat className="h-5 w-5" />,
  },
  {
    name: "Lave-vaisselle",
    icon: <Droplets className="h-5 w-5" />,
  },
  {
    name: "Cafetière",
    icon: <Coffee className="h-5 w-5" />,
  },
];

const allAmenities: AmenityCategory[] = [
  {
    category: "Cuisine",
    items: [
      { name: "Four traditionnel", icon: <ChefHat className="h-5 w-5" /> },
      { name: "Four à micro-ondes", icon: <ChefHat className="h-5 w-5" /> },
      { name: "Réfrigérateur combiné congélateur", icon: <Snowflake className="h-5 w-5" /> },
      { name: "Plaque vitrocéramique à induction", icon: <Flame className="h-5 w-5" /> },
      { name: "Lave-vaisselle", icon: <Droplets className="h-5 w-5" /> },
      { name: "Cafetière", icon: <Coffee className="h-5 w-5" /> },
      { name: "Théière", icon: <Coffee className="h-5 w-5" /> },
      { name: "Grille-pain", icon: <UtensilsCrossed className="h-5 w-5" /> },
      { name: "Bouilloire électrique", icon: <Coffee className="h-5 w-5" /> },
      { name: "Presse-agrume électrique", icon: <UtensilsCrossed className="h-5 w-5" /> },
      { name: "Balance électronique", icon: <Scale className="h-5 w-5" /> },
      { name: "Appareil à raclette", icon: <UtensilsCrossed className="h-5 w-5" /> },
      { name: "Blender chauffant", icon: <UtensilsCrossed className="h-5 w-5" /> },
      { name: "Mixeur plongeant et accessoires", icon: <UtensilsCrossed className="h-5 w-5" /> },
      { name: "Torchons, essuie-mains et tablier fournis", icon: <Shirt className="h-5 w-5" /> }
    ]
  },
  {
    category: "Pièce à vivre",
    items: [
      { name: "Poêle à granulés", icon: <Heater className="h-5 w-5" /> },
      { name: "Grand canapé", icon: <Sofa className="h-5 w-5" /> },
      { name: "Téléviseur connecté 55 pouces", icon: <Tv className="h-5 w-5" /> },
      { name: "Nombreux jeux de société et cartes", icon: <Gamepad2 className="h-5 w-5" /> },
      { name: "Chaîne hifi bluetooth", icon: <Music className="h-5 w-5" /> },
      { name: "Grande table à manger", icon: <Table className="h-5 w-5" /> }
    ]
  },
  {
    category: "Suite parentale",
    items: [
      { name: "Lit double 160cm", icon: <BedDouble className="h-5 w-5" /> },
      { name: "Linge de lit fourni", icon: <Shirt className="h-5 w-5" /> },
      { name: "Dressing", icon: <Home className="h-5 w-5" /> },
      { name: "Salle de bain privative", icon: <Bath className="h-5 w-5" /> },
      { name: "Pèse-personne", icon: <Weight className="h-5 w-5" /> },
      { name: "Sèche-cheveux", icon: <Wind className="h-5 w-5" /> },
      { name: "Douche 120x80cm", icon: <Droplets className="h-5 w-5" /> },
      { name: "Sèche-serviettes", icon: <Heater className="h-5 w-5" /> },
      { name: "Serviettes de toilette fournies", icon: <Shirt className="h-5 w-5" /> }
    ]
  },
  {
    category: "Chambre enfants",
    items: [
      { name: "Deux lits simples 90cm", icon: <Bed className="h-5 w-5" /> },
      { name: "Linge de lit fourni", icon: <Shirt className="h-5 w-5" /> },
      { name: "Livres pour enfants", icon: <Book className="h-5 w-5" /> },
      { name: "Crayons de couleur", icon: <Palette className="h-5 w-5" /> }
    ]
  },
  {
    category: "Chambre avec accès terrasse",
    items: [
      { name: "Lit double 160cm", icon: <BedDouble className="h-5 w-5" /> },
      { name: "Linge de lit fourni", icon: <Shirt className="h-5 w-5" /> },
      { name: "Accès terrasse", icon: <DoorOpen className="h-5 w-5" /> }
    ]
  },
  {
    category: "Salle de bain",
    items: [
      { name: "Double vasque", icon: <Bath className="h-5 w-5" /> },
      { name: "Douche 120x80cm", icon: <Droplets className="h-5 w-5" /> },
      { name: "Serviettes de toilette fournies", icon: <Shirt className="h-5 w-5" /> },
      { name: "Sèche-serviettes", icon: <Heater className="h-5 w-5" /> }
    ]
  },
  {
    category: "Buanderie",
    items: [
      { name: "Douche 120x80cm", icon: <Droplets className="h-5 w-5" /> },
      { name: "Sèche-linge", icon: <Wind className="h-5 w-5" /> },
      { name: "Lave-linge", icon: <WashingMachine className="h-5 w-5" /> },
      { name: "Table à repasser", icon: <Home className="h-5 w-5" /> },
      { name: "Fer à repasser", icon: <Shirt className="h-5 w-5" /> },
      { name: "Étendoir à linge", icon: <Shirt className="h-5 w-5" /> },
      { name: "Aspirateur sans fil", icon: <Wind className="h-5 w-5" /> }
    ]
  },
  {
    category: "Équipements enfants",
    items: [
      { name: "Chaise haute", icon: <Baby className="h-5 w-5" /> },
      { name: "Lit parapluie", icon: <Baby className="h-5 w-5" /> },
      { name: "Marchepied", icon: <Baby className="h-5 w-5" /> }
    ]
  },
  {
    category: "Extérieur",
    items: [
      { name: "Jardin clos", icon: <Trees className="h-5 w-5" /> },
      { name: "Jeux d'extérieur (jeux en bois, boules de pétanque, etc.)", icon: <Gamepad2 className="h-5 w-5" /> },
      { name: "Balançoire", icon: <Users className="h-5 w-5" /> },
      { name: "Terrasse en bois de 75m²", icon: <Home className="h-5 w-5" /> },
      { name: "Barbecue à gaz", icon: <Flame className="h-5 w-5" /> },
      { name: "Table à manger", icon: <Table className="h-5 w-5" /> },
      { name: "6 chaises", icon: <Armchair className="h-5 w-5" /> },
      { name: "2 fauteuils", icon: <Armchair className="h-5 w-5" /> },
      { name: "Salon de jardin", icon: <Sofa className="h-5 w-5" /> },
      { name: "4 fauteuils", icon: <Armchair className="h-5 w-5" /> },
      { name: "Table basse", icon: <Table className="h-5 w-5" /> },
      { name: "4 bains de soleil", icon: <Sun className="h-5 w-5" /> },
      { name: "2 voiles d'ombrage", icon: <Umbrella className="h-5 w-5" /> }
    ]
  },
  {
    category: "Pour la plage",
    items: [
      { name: "Nombreux jeux de plage", icon: <Gamepad2 className="h-5 w-5" /> },
      { name: "Parasol", icon: <Umbrella className="h-5 w-5" /> },
      { name: "Planche de body surf", icon: <Wind className="h-5 w-5" /> },
      { name: "Serviettes de plage (1 par personne par séjour, du 1er juin au 30 septembre)", icon: <Shirt className="h-5 w-5" /> },
      { name: "Sac à dos isotherme", icon: <Snowflake className="h-5 w-5" /> },
      { name: "Vaisselle pour pique-nique", icon: <UtensilsCrossed className="h-5 w-5" /> }
    ]
  }
];

const AmenitiesList: React.FC = () => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  return (
    <div className="py-6 animate-fade-in">
      <h2 className="text-xl md:text-2xl font-semibold mb-6">Ce que propose ce logement</h2>
      
      <div className="grid grid-cols-2 md:grid-cols-3 gap-x-8 gap-y-6">
        {amenities.map((amenity, index) => (
          <div key={index} className="flex items-center gap-3">
            <div className="text-gray-600">
              {amenity.icon}
            </div>
            <span className="text-sm md:text-base">{amenity.name}</span>
          </div>
        ))}
      </div>
      
      <button 
        className="mt-8 border border-gray-300 rounded-lg px-5 py-2 font-medium hover:bg-gray-50 transition"
        onClick={() => setIsDialogOpen(true)}
      >
        Afficher tous les équipements
      </button>
      
      <Dialog open={isDialogOpen} onOpenChange={setIsDialogOpen}>
        <DialogContent className="sm:max-w-[550px] max-h-[85vh] overflow-hidden">
          <DialogHeader className="px-6 pt-6 pb-4">
            <DialogTitle className="text-2xl font-semibold">Ce que propose ce logement</DialogTitle>
          </DialogHeader>
          
          <ScrollArea className="max-h-[70vh] overflow-y-auto">
            <div className="pr-4">
              {allAmenities.map((category, categoryIndex) => (
                <div 
                  key={categoryIndex} 
                  className={`px-6 py-5 ${categoryIndex % 2 === 0 ? 'bg-white' : 'bg-gray-50'}`}
                >
                  <h3 className="text-xl font-medium mb-4">{category.category}</h3>
                  
                  <div className="space-y-4">
                    {category.items.map((item, itemIndex) => (
                      <div key={itemIndex}>
                        <div className="flex items-center gap-4">
                          <div className="text-gray-600 flex-shrink-0">
                            {item.icon}
                          </div>
                          <span className="text-base">{item.name}</span>
                        </div>
                        {itemIndex < category.items.length - 1 && (
                          <Separator className="my-4" />
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </ScrollArea>
        </DialogContent>
      </Dialog>
      
      <Separator className="my-8" />
    </div>
  );
};

export default AmenitiesList;
